export enum BulkEditSection {
    AddScreen = "Add Screen",
    EditHeader = "Edit Header",
    InputCell = "Input Cell"
}
